import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_dialog_close_button = _resolveComponent("oxd-dialog-close-button")!
  const _component_oxd_sheet = _resolveComponent("oxd-sheet")!
  const _component_oxd_overlay = _resolveComponent("oxd-overlay")!

  return (_openBlock(), _createBlock(_Transition, {
    name: _ctx.computedTransition,
    appear: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_oxd_overlay, {
        role: "dialog",
        centered: "",
        show: true,
        onClick: _ctx.onClickOverlay
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dialogContainer), null, {
            default: _withCtx(() => [
              _createVNode(_component_oxd_sheet, _mergeProps({
                class: _ctx.classes,
                gutters: false
              }, _ctx.$attrs, {
                role: "document",
                onClick: _ctx.onClickSheet
              }), {
                default: _withCtx(() => [
                  (_ctx.withClose)
                    ? (_openBlock(), _createBlock(_component_oxd_dialog_close_button, {
                        key: 0,
                        class: "oxd-dialog-close-button-position",
                        onClick: _ctx.onClose
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                _: 3
              }, 16, ["class", "onClick"])
            ]),
            _: 3
          }))
        ]),
        _: 3
      }, 8, ["onClick"])
    ]),
    _: 3
  }, 8, ["name"]))
}